<template>            
        <v-layout row wrap>            
            <v-flex >
                <v-card class="elevation-0">
                    <!--TODO:  Separa toolbar a otro componente-->
                    <!--v-toolbar 
                    v-if="$store.state.usuario.type == 'Cliente'"
                    dense 
                    flat 
                    color="blue" 
                    class="noborderradius" 
                    dark>                    

                    <v-toolbar-title>Pedido</v-toolbar-title>

                    <v-spacer></v-spacer>
                   
                    </v-toolbar-->
                    <v-data-iterator
                        
                        :items="listitems"
                        class="elevation-1"
                        rows-per-page-text="Productos por página"
                        :rows-per-page-items="rowsperpageitems"  
                        @update:pagination="$vuetify.goTo(0)"
                                              
                    >
                        <!--template v-slot:items="props">
                        <td>{{ props.item.no }}</td>                        
                        <td class="text-xs-left">{{ props.item.description }}</td>
                        <td v-if="$store.state.tipoDocumento != 'abono'" class="text-xs-center">{{ props.item.cantidad }}</td>
                        <td v-else class="text-xs-center">{{ -props.item.cantidad }}</td>
                        <td v-if="$store.state.appconfig.allowUOMS" class="text-xs-center">{{ props.item.uom }}</td>
                        <td v-if="$store.state.appconfig.autoventa" class="text-xs-center">{{ props.item.lote }}</td>
                        <td class="text-xs-center">{{ parseFloat(props.item.descuento).toFixed(2) }}</td>
                        <td class="text-xs-center">{{ parseFloat(props.item.precio).toFixed(2) }}</td>
                        <td v-if="$store.state.appconfig.showVAT" class="text-xs-center">{{ props.item.prodPostingGroup }}</td>
                        <td v-if="$store.state.tipoDocumento != 'abono'" class="text-xs-center">{{ totalImporteLinea(props.item,false)}}</td>
                        <td v-else class="text-xs-center">{{ totalImporteLinea(props.item,true) }}</td>
                        <td class="justify-center layout px-0">
                        <v-icon
                            small
                            class="mr-2"
                            @click="editItem(props.item)"
                        >
                            edit
                        </v-icon>
                        <v-icon
                            small
                            @click="deleteItem(props.item)"
                        >
                            delete
                        </v-icon>
                        </td>
                        </template-->
                        <template v-slot:item="props">
                        <v-card class="elevation-1 mb-1 mt-1">
                            <v-layout wrap row>
                                <v-flex xs8>
                                    <v-card-title dense class="cardTitleGrid bold-text">{{props.item.description}} </v-card-title>
                                    <div class="subtitleGrid" v-if="props.item.Alias != props.item.description"><span class="itemAlias">{{ props.item.Alias }}</span></div>
                                    <div class="subtitleGrid" ><span class="itemIdCard">{{ props.item.no }}</span></div>
                                    <div class="subtitleGrid" v-if="$store.state.appconfig.autoventa || ($store.state.tipoDocumento == 'abono')">
                                        <span class="itemIdCard">{{ props.item.lotesCaption }}</span>
                                    </div>
                                    <v-layout wrap row>
                                        <v-flex xs3>
                                            <v-icon
                                                medium
                                                class="ml-2"
                                                @click="editItem(props.item)"
                                            >
                                                edit
                                            </v-icon>
                                        </v-flex>
                                        <v-flex xs3>
                                            <v-icon
                                                medium
                                                @click="deleteItem(props.item)"
                                            >
                                                delete
                                            </v-icon>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs4>
                                    <v-card-title dense class="cardTitleGrid bold-text">{{props.item.cantidad}} {{ props.item.uom }} </v-card-title>
                                    <div class="subtitleGrid" v-if="parseFloat(props.item.descuento) != 0"><span class="itemIdCard">- {{ parseFloat(props.item.descuento).toFixed(2) }} %</span> </div>
                                    <div class="subtitleGrid"><span class="itemIdCard">{{ parseFloat(props.item.precio).toFixed(2) }} €/udm </span></div>
                                    <div class="subtitleGrid" v-if="$store.state.appconfig.showVAT"><span  class="itemIdCard">IGIC: {{ props.item.prodPostingGroup }} %</span></div>
                                    <div class="subtitleGrid" v-if="$store.state.tipoDocumento != 'abono'" ><span class="itemIdCard bold-text">{{ totalImporteLinea(props.item,false,$store.state.appconfig.showVAT) }} €</span></div>
                                    <div class="subtitleGrid" v-else ><span class="itemIdCard bold-text">{{ totalImporteLinea(props.item,true,$store.state.appconfig.showVAT) }} €</span></div>
                                </v-flex>   
                            </v-layout>
                            <br>
                        </v-card>
                        </template>
                        <template v-slot:no-data>
                            <v-alert :value="true" color="error" icon="warning">
                                Añada productos en la pestaña 'Catálogo'
                            </v-alert>
                        </template>
                    </v-data-iterator >
                    <!--TODO: Separar en componentes totales y botonera-->
                    <v-list two-line style="padding: 0px;">                                                                                                                                         
                        <v-subheader>Totales</v-subheader>
                        <v-list-tile>                                                
                            <v-list-tile-content class="totalesContent">   
                                <v-layout
                                v-if="showCustDiscount()"
                                 row caption>
                                    Descuento Cliente: {{ custDiscount() }}%
                                </v-layout>   
                                <v-layout row caption>
                                    Descuentos: {{totalDescuentoPedido}}
                                </v-layout>   
                                <v-layout 
                                v-if="$store.state.appconfig.showVAT"
                                row caption>
                                    IGIC: {{totalImpuestoPedido}}
                                </v-layout>  
                                <v-layout row>
                                    TOTAL:&nbsp;<span class="font-weight-bold">{{totalImportePedido}}</span>
                                </v-layout>  
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                        <v-container grid-list-md pt-0>  
                            <v-layout wrap>  
                                <v-flex xs12>
                                    <v-btn 
                                    color="warning" 
                                    :loading="loading"
                                    :disabled="loading || (listitems.length == 0)"
                                    block
                                    class="white--text"
                                    @click="guardaPedido()"
                                    > 
                                        Guardar Pedido
                                        <v-icon right dark>save</v-icon>
                                    </v-btn>
                                    <!--v-if="($store.state.usuario.type == 'Cliente')"-->
                                </v-flex>
                                <v-flex xs12>
                                <v-btn 
                                    v-if="($store.state.usuario.type == 'Comercial')"
                                    color="primary" 
                                    :loading="loading"
                                    :disabled="loading"
                                    class="white--text"
                                    block
                                    @click="cargarPedido()"
                                    > 
                                        Cargar Pedido
                                        <v-icon right dark>download</v-icon>
                                    </v-btn>
                                    <!--v-if="($store.state.usuario.type == 'Cliente')"-->
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn 
                                    color="error" 
                                    href="" 
                                    target="_blank"
                                    block
                                    @click="resetOrderItems()"
                                    > 
                                        Borrar pedido
                                        <v-icon right dark>delete</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn 
                                    color="success" 
                                    :loading="loading"
                                    :disabled="loading || (listitems.length == 0)"
                                    block
                                    class="white--text"
                                    @click="creaPedido(false)"
                                    > 
                                        Enviar Pedido
                                        <v-icon right dark>cloud_upload</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12>
                                    <v-btn 
                                    v-if="($store.state.usuario.type == 'Comercial') && ($store.state.tipoDocumento == 'autoventa') && ($store.state.customer.combineShipments == 'No')"
                                    color="blue darken-1" 
                                    :loading="loading"
                                    :disabled="loading || (listitems.length == 0)"
                                    block
                                    class="white--text"
                                    @click="creaPedido(true)"
                                    > 
                                        Enviar Pedido y cobrar
                                        <v-icon right dark>cloud_upload</v-icon>
                                    </v-btn>
                                </v-flex>
                                
                                <v-flex xs12>
                                    <v-badge 
                                        v-model="show"
                                        overlap
                                        >
                                        <template v-slot:badge>
                                            <span>{{commentsLength()}}</span>
                                        </template>
                                        <v-btn
                                            color="primary"
                                            flat
                                            @click="gotoComments()"
                                        >
                                            Comentarios de Tarea
                                        </v-btn>
                                    </v-badge>
                                </v-flex>
                            </v-layout>
                        </v-container>
                </v-card>
            </v-flex>
            <!--TODO Llevar el dialog a otro componente-->
            <v-dialog v-model="dialog">                
                <v-card>
                <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                
                <v-card-text>
                    <v-container grid-list-md pa-0>
                    <ul>
                        <li v-for="error in errors" :key="error.id">
                            <v-alert :value="true" color="error" icon="warning"> {{ error.msg }}
                            </v-alert>      
                        </li>                  
                    </ul>
                    <!--span><v-alert v-if="errors.items.length != 0" :value="true" color="error" icon="warning">{{ errors.first('dto') }}</v-alert> </span-->
                    <v-layout wrap>
                        <v-flex xs6 sm4 md3>
                            <v-text-field v-model="editedItem.cantidad" type="number" label="Cantidad" @focus="$event.target.select()" v-validate="'min_value:0'" name="cantidad"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.precio" type="number" label="Precio" @focus="$event.target.select()" @change="editedItem.precioEditado = true" v-validate="'min_value:0'" name="precio"></v-text-field>
                        </v-flex>
                        <v-flex xs6 sm4 md3 v-if="$store.state.usuario.editPrices">
                            <v-text-field v-model="editedItem.descuento" type="number" label="Descuento" @focus="$event.target.select()" v-validate="'max_value:100|min_value:0'" name="dto"></v-text-field>                        
                        </v-flex>
                        <v-flex xs6 sm4 md3
                        v-if="editedItem.trackingEnabled">
                            <v-select
                                :items="editedItem.lotes"
                                :item-text="loteCaption"
                                item-value="lote"
                                label="Lote"
                                v-model="editedItem.lote"
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="close">Cancelar</v-btn>
                    <v-btn color="blue darken-1" flat @click="save">Guardar</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>            
</template>
<script>
//import mixin from '@/components/mixin.js'
export default {
    //mixins:[mixin],
    name: 'pedidoMobile',
    data: () => ({
        loader: null,
        //loading: false,
        nota: '',
        date: new Date().toISOString().substr(0, 10),      
        menu: false,       
        valid: true,            
        select: null,   
        card: false,     
        //rowsperpageitems: [5,10,25,{"text":"Todos","value":-1}],
        rowsperpageitems: [{"text":"Todos","value":-1}],
        headers: [
            {
            text: 'Código',
            align: 'left',
            sortable: false,
            value: 'code'
            },
            { text: 'Descripción', value: 'description' },
            { text: 'Cantidad', value: 'quantity' },
            { text: 'UD', value: 'uom' },
            { text: 'Lote', value: 'lote' },
            { text: 'Descuento', value: 'discount' },
            { text: 'Precio', value: 'price' },
            { text: '% IGIC', value: 'prodPostingGroup' },
            { text: 'Total', value: 'total' },
            { text: 'Acciones', value: 'name', sortable: false }
        ],
        editedIndex: -1,
        editedItem: {
            cantidad: 0
        },
        dialog: false,
        invCustDiscount: 0,
        timeoutCommit: null,
        show: false
    }),
    methods: {
        custDiscount(){
            var total = this.totalImportePedidoMain(false);
            var discounts = [];
            var dto = 0;
            try{
                if (this.$store.state.usuario.type == 'Cliente'){                
                    discounts = this.$store.state.usuario.invoiceDisc;
                } else {
                    discounts = this.$store.state.customer.discounts;                
                }            
                for (var i = 0; i < discounts.length; i++){
                    //Estan ordenados de mayor a menor, se recorre el array
                    if (discounts[i].minAmount <= total) dto = discounts[i].discount;
                }
            } catch (e){

            }
            return dto;
        },
        showCustDiscount(){
            if (this.$store.state.usuario.type == 'Cliente'){
                if (this.$store.state.usuario.invoiceDisc.length != 0)
                    return true                
            } else {
                if ((this.$store.state.customer != {}) && (this.$store.state.customer.discounts.length != 0)){
                    return true;
                }
            }
            return false;
        },
        loteCaption(item){
            if(item.caducidad != ''){
                return item.lote + '(' + item.disponible + ') - ' + item.caducidad;
            } else {                
                return item.lote + '(' + item.disponible + ')';
            }            
        }, 
        gotoComments(){
            this.$store.state.visitaComentarios = true;
            this.$router.push('comentarios');
        },
        commentsLength(){
            if (this.comentarios.length){
                if ((this.comentarios.length == 1) && (this.comentarios[0].comment == '')) {
                    this.show = false;
                    return 0;
                } else {
                    this.show = true;
                    return this.comentarios.length;
                }
            } else {
                this.show = false;
                return 0;
            }
        },
        gotoSearch(){
            this.$router.push('menu');
        },           
        resetOrderItems(){
            this.setGlobalConfirmDialog('Confirmación','¿Desea borrar el pedido?',true);
            //this.$store.commit("resetOrderItems");
            //this.navigate(1);
        },
        creaPedido(cobrar){
            //this.loading = !this.loading;
            this.$store.commit("setLoading");
            var total = this.totalImportePedidoMain(true);
            this.createOrder(cobrar,total);
        },
        guardaPedido(){
            this.$store.commit("setLoading");
            this.saveOrder(true);
        },
        cargarPedido(){
            if (this.listitems.length > 0){
                if (!confirm('Si continúa se vaciará la cesta actual. ¿Desea continuar?')){
                    return;
                }
            }
            this.$store.commit("setLoading");
            this.getStoredOrder(true);
        },
        editItem (item) {        
            this.editedIndex = this.listitems.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.editedItem.cantidad = item.cantidad;
            this.dialog = true
        },
        deleteItem (item) {
            const index = this.listitems.indexOf(item)
            if (confirm('¿Desea eliminar el producto?')){
                this.listitems.splice(index, 1);  
                this.recalcPromos();
            }
        },
        recalcPromos(){
            for (var i = 0; i < this.listitems.length;){
                if (this.listitems[i].isPromo){
                    this.listitems.splice(i, 1);
                } else {
                    i++;
                }
            }
            for (i = 0; i < this.listitems.length; i++){
                if (!this.listitems[i].isPromo){
                    this.checkitemPromo(this.listitems[i]);
                }
            }
        },
        close () {
            this.dialog = false        
        },
        save () {    
            this.$validator.validate().then(valid => {
                if (!valid) {
                    ok = false;
                } else {
                    if (this.editedItem.trackingEnabled){
                        var ok = true;
                        if (!this.editedItem.lote) ok = false;                
                        if (!ok){
                            this.setGlobalDialog('Lote requerido','Uno o mas de los productos que ha introducido carecen de lote. Revise los datos.',false);
                            return;
                        } else {
                            var resLote = this.editedItem.lotes.find(itm =>{
                                return itm.lote == this.editedItem.lote;
                            });
                            if (resLote.length == undefined) resLote = [resLote];
                            var orderQty = 0;
                            //Control de cantidad en otras lineas en pedido   
                            //Revisar e intentar hacerlo igual que en la lista catalogo, que la variable que se le pasa
                            //al edit item sea una shallow copy de orderItems            
                            /*var res = this.listitems.filter(itm =>{
                                return (itm.lote == this.editedItem.lote) && (itm.no == this.editedItem.no);
                            });        
                            if (res != undefined) {
                                if (res.length == undefined) res = [res];            
                                for (var j = 0; j < res.length; j++){
                                    orderQty += parseFloat(res[j].cantidad);
                                }
                            }
                            if (parseFloat(resLote[0].disponible) < orderQty){
                                this.setGlobalDialog('Exceso de cantidad', 'Se ha introducido mayor cantidad (' + orderQty + ') que la disponible para el lote ' + this.editedItem.lote + ' (' + resLote[0].disponible + ')',false);
                                return;
                            }        
                            if ((this.editedItem.precio == 0) && (this.editedItem.descuento != 100)){
                                this.setGlobalDialog('Línea sin precio', 'No se ha introducido precio para el producto ' + this.editedItem.no ,false);
                                return;
                            }     */   
                        }
                    }   
                    Object.assign(this.listitems[this.editedIndex], this.editedItem);
                    this.recalcPromos();
                    this.close();
                }
            });            
        },
        totalImportePedidoMain(calcVAT){
            var total = 0;
            var dto = 0;
            var igic = 0;
            var dto_cliente = 0;
            //%Descuento cliente
            if (calcVAT){                
                dto_cliente = this.custDiscount();
            }

            for (var i = 0; i < this.listitems.length; i++){
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precio * this.listitems[i].cantidad /* this.listitems[i].qtyperuom*/).toFixed(2));
                    var dto_linea = parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                    dto += dto_linea;                    
                    total += lineAmount;
                    if (calcVAT){
                        var lineAmountforVAT = lineAmount - dto_linea;
                        lineAmountforVAT -= parseFloat(dto_cliente/100*lineAmountforVAT);
                        var igic_linea = parseFloat((this.listitems[i].prodPostingGroup/100 * lineAmountforVAT).toFixed(2));                    
                        igic += igic_linea;
                    }
                }
            }

            dto += parseFloat((dto_cliente/100 * (total - dto)).toFixed(2));
                        
            //Se aplcia redondeo al desceunto para que cuadre con NAV
            if (this.$store.state.tipoDocumento != 'abono')
                if (this.$store.state.appconfig.showVAT)
                    return (total-dto+igic);    
                else
                    return (total-dto);
            else 
                if (this.$store.state.appconfig.showVAT)
                    return ((total-dto+igic) * -1);    
                else 
                    return ((total-dto) * -1);
        },
        totalImporteLinea(item, abono){
            var res = 0;
            if (abono) 
                res = ((item.precio * -item.cantidad) - ((item.precio * -item.cantidad)*(item.descuento/100))).toFixed(2);                 
             else 
                res = ((item.precio * item.cantidad) - ((item.precio * item.cantidad)*(item.descuento/100))).toFixed(2); 
            res = parseFloat(res) /** parseFloat(item.qtyperuom)*/;
            if (this.$store.state.appconfig.showVAT)
                res = parseFloat(res) + ((parseFloat(item.prodPostingGroup)/100)*parseFloat(res));            
            return res.toFixed(2);
        }
    },
    watch: {
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        },      
        loader () {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        }    
    },
    components: {        
    },
    computed: {
        comentarios: {
            get(){
                return this.$store.state.dialogCreateTodoData.comentarios;
            }
        },
        errors:{
            get(){
                return errors.first('dto');
            }
        },
        listitems: {
            get(){
                return this.$store.state.orderItems;
            },
            set(value){
                this.$store.commit('setOrderItems',value)
            }
        },
        loading:{
            get(){
                return this.$store.state.creatingOrder;
            }
        },
        nombreUsuario: {
            get() {
                return this.$store.state.usuario.nombre;
            }
        },
        computedDateFormatted () {
            return this.formatDate(this.date)
        },
        totalImportePedido(){
            return this.totalImportePedidoMain(true).toFixed(2) + ' €' ;
        },
        totalImpuestoPedido(){
            var total = 0;
            var dto = 0;
            var igic = 0;
            var dto_cliente = '';
            //% Descuento cliente
            var dto_cliente = this.custDiscount();            

            for (var i = 0; i < this.listitems.length; i++){
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precio * this.listitems[i].cantidad /** this.listitems[i].qtyperuom*/).toFixed(2));
                    var dto_linea = parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                    lineAmount -= dto_linea;
                    lineAmount -= parseFloat(dto_cliente/100*lineAmount)
                    var igic_linea = parseFloat((this.listitems[i].prodPostingGroup/100 * lineAmount).toFixed(2));                                        
                    igic += igic_linea;
                }
            }
            return igic.toFixed(2) + ' €';   
        },
        totalDescuentoPedido(){
            var total = 0;
            var dto = 0;
            for (var i = 0; i < this.listitems.length; i++){                
                if (this.listitems[i].item){
                    var lineAmount = parseFloat((this.listitems[i].precio * this.listitems[i].cantidad /** this.listitems[i].qtyperuom*/).toFixed(2));
                    total += lineAmount;
                    dto += parseFloat((this.listitems[i].descuento/100 * lineAmount).toFixed(2));
                }                    
            }
            //Descuento cliente
            var dto_cliente = this.custDiscount();            
            if (this.$store.state.usuario.invoiceDisc != 0){
                dto += parseFloat((dto_cliente/100 * (total - dto)).toFixed(2));
            }
           
            return dto.toFixed(2) + ' €';
        },
        formTitle () {
            if ((this.editedIndex > -1) && (this.listitems[this.editedIndex] != undefined))
                return this.listitems[this.editedIndex].no + ' - ' + this.listitems[this.editedIndex].description;
        }
    },
    mounted(){  
        this.checkSession();
        if (!this.$store.state.appconfig.showVAT){
            var res = this.headers.find(header =>{
                return header.text == '% IGIC';
            });
            if (res)
                this.headers.splice(7,1);
        }     
        if (!this.$store.state.appconfig.autoventa){
            var res = this.headers.find(header =>{
                return header.text == 'Lote';
            });
            if (res)
                this.headers.splice(4,1);
        }      
        if (!this.$store.state.appconfig.allowUOMS){
            var res = this.headers.find(header =>{
                return header.text == 'UD';
            });
            if (res)
                this.headers.splice(3,1);
        };

        
        
    },
    created(){
        //this.listitems = this.$store.state.orderItems.slice();
        /*for (var i = 0; i < this.listitems.length; i=i+2){
            var divider = { divider: true, inset: true };
            this.listitems.splice(i,0,divider);            
        }*/
    }
}
</script>
<style scoped>
 .noborderradius{
     border-radius: 0px !important;
 }
 .inneritemflex{
     width: 100%;
 }
 .totalesContent{
     text-align: -webkit-right;
 }
 .itemId{
     color: gray;
     font-weight: 200;
 }
 li {
    list-style-type: none;
 }
 .payDiv{
  height: 100%;
  display: none;
}
.bold-text{
     font-weight: bold;
 }
.cardTitleGrid{
    padding-top: 2px !important;
    padding-bottom: 2px !important;
    height: auto;
 }
 .subtitleGrid{
    padding-left: 15px;;
 }
 </style>